import { orderBy } from "lodash";
import { apiAddress } from "../../config/server";
import { IReport } from "../../types/reports/reports";
import { ApiBase } from "./baseApi";

export default class ReportsApi extends ApiBase {
  static RatesApiAddress = `${apiAddress}/api/reports`;

  static GetList = ReportsApi.RatesApiAddress;

  static getList(): Promise<IReport[]> {
    return this.get<IReport[]>(this.GetList).then((response) =>
      orderBy(response.data.data, (r) => r.order || 0),
    );
  }
}
